import MasterCatalogs from './MasterCatalogs'
export default MasterCatalogs;